export default __webpack_public_path__ + "static/media/about-us-icon-use-life.ecabf046.png";